// extracted by mini-css-extract-plugin
export default {"backdrop":"drawer_backdrop__axvu1","open":"drawer_open__Sy0rS","drawer":"drawer_drawer__yJw80","header":"drawer_header__RHEGz","closeButton":"drawer_closeButton__PaMvb"};